<script lang="ts">
	import { formOpen, masters, selectedMaster } from '$lib/index.svelte';
	import cross from '$lib/assets/images/cross.svg';
	import check from '$lib/assets/images/check.svg';

	const currentMaster = masters[selectedMaster.idx ?? 0];
	let firstName = $state('');
	let lastName = $state('');
	let email = $state('');
	let website = $state('');
	let status = $state<'idle' | 'sending' | 'ok' | 'error'>('idle');
	let errorMsg = $state('');

	async function handleSubmit(e: SubmitEvent) {
		e.preventDefault();
		status = 'sending';
		errorMsg = '';

		try {
			const res = await fetch('/api', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					firstName: firstName,
					lastName: lastName,
					email: email,
					master: currentMaster.firstName + ' ' + currentMaster.lastName,
					website // honeypot
				})
			});

			if (!res.ok) {
				const err = await res.json();
				status = 'error';
				console.log(err);
			}

			status = 'ok';
			firstName = '';
			lastName = '';
			email = '';
		} catch (err) {
			status = 'error';
			errorMsg = err instanceof Error ? err.message : 'Unknown error';
		}
	}
</script>

<div
	class="fixed inset-0 z-5 flex min-h-lvh w-full items-center justify-center bg-black/10 backdrop-blur-2xl md:p-5"
>
	<div
		class="max-h-screen w-140 overflow-auto bg-theme-brown px-8 pb-10 text-black md:max-h-[calc(100vh-40px)]"
	>
		{#if status === 'ok'}
			<div class="flex h-screen flex-col items-center justify-center">
				<div
					class="mt-10 flex aspect-square w-22 items-center justify-center rounded-full bg-black"
				>
					<img class="h-5 w-6.75" src={check} alt="" />
				</div>
				<h3
					class="py-10 text-center text-xl font-semibold tracking-[-1px] uppercase md:text-[28px]"
				>
					You’re all set
				</h3>
				<p class="mb-10 text-center">
					We’ve received your details, and your Mifroma adventure is ready to begin!<br />
					Your Maître Fromager is now ready to guide you.
				</p>
				<button
					class="rounded-sm border border-black bg-black p-3 font-semibold text-theme-brown uppercase"
					onclick={() => {
						status = 'idle';
						formOpen.status = false;
					}}>GO BACK HOME</button
				>
			</div>
		{:else}
			<div class="sticky top-0 mb-5 flex items-center justify-between bg-theme-brown pt-5 pb-5">
				<p></p>
				<h2 class="font-semibold uppercase">Confirmation</h2>
				<button
					onclick={() => {
						formOpen.status = false;
					}}
					aria-label="Close the quiz"><img src={cross} alt="" /></button
				>
			</div>
			<div class=" mb-10">
				<div class="mx-auto mb-10 aspect-square sm:aspect-auto sm:h-76.25 sm:w-67.5">
					<img
						class="h-full w-full border-10 border-taupe-200 object-cover"
						src={currentMaster.image}
						alt="{currentMaster.firstName} {currentMaster.lastName}'s portrait"
					/>
				</div>
				<h3 class="text-center text-[28px] font-semibold tracking-[-1px] uppercase">
					{currentMaster.firstName}
					{currentMaster.lastName}
				</h3>
				<p class="my-2 text-center text-xl underline">
					I’m super happy to begin this adventure together!
				</p>
				<p class=" text-center text-xl underline">See you soon for the journey ahead!</p>
			</div>
			<form onsubmit={handleSubmit}>
				<div class="mb-3.5 flex flex-col gap-3.5 md:flex-row">
					<div class="flex flex-1 flex-col gap-2.5">
						<label class="text-sm font-semibold uppercase" for="firstname">First name</label>
						<input
							class="border border-black px-3.5 py-4 font-mono"
							id="firstname"
							bind:value={firstName}
							placeholder="First name"
							required
						/>
					</div>
					<div class="flex flex-1 flex-col gap-2.5">
						<label class="text-sm font-semibold uppercase" for="lastname">Last name</label>
						<input
							class="border border-black px-3.5 py-4 font-mono"
							id="lastname"
							bind:value={lastName}
							placeholder="Last name"
							required
						/>
					</div>
				</div>
				<div class="flex w-full flex-col gap-2.5">
					<label class="text-sm font-semibold uppercase" for="email">Email</label>
					<input
						class="border border-black px-3.5 py-4 font-mono"
						id="email"
						bind:value={email}
						type="email"
						placeholder="Email"
						required
					/>
				</div>

				<!-- Honeypot: hidden from humans, visible to bots -->
				<input
					bind:value={website}
					name="website"
					tabindex="-1"
					autocomplete="off"
					aria-hidden="true"
					style="position:absolute; left:-9999px; opacity:0;"
				/>

				<button
					class="mt-5 rounded-sm bg-black px-4 py-3 font-semibold text-theme-brown uppercase md:mt-10"
					type="submit"
					disabled={status === 'sending'}
				>
					{status === 'sending' ? 'Sending…' : 'Confirm'}
				</button>

				{#if status === 'error'}
					<p class="error">{errorMsg}</p>
				{/if}
			</form>
		{/if}
	</div>
</div>
